import AnimeUtils from '../common/utils/anime.es6';
import ConvertUtils from '../common/utils/convert.es6';
import ObjUtils from '../common/utils/obj.es6';
import Swiper from 'swiper/bundle';

const MAIN_WIDTH = 780;
const BNR_WIDTH = 520;
const NUM_ALLOWED_LOOP = 2;

export default class Slider {
    constructor() {
        this.swipers = {};

        this._setSlider();
        this._setBnrBullets();
    }

    _setSlider() {
        const $sliders = [...document.querySelectorAll('.js-slider')];
        let prevIndex = 0;

        // 共通のパラメータ
        const commonParams = {
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
                waitForTransition: false,
            },
            centeredSlides: true,
            navigation: {
                nextEl: '.js-slider_nextBtn',
                prevEl: '.js-slider_prevBtn',
            },
            pagination: {
                bulletActiveClass: '-active',
                bulletClass: 'c-hover_op',
                bulletElement: 'button',
                clickable: true,
                el: '.js-slider_pagination',
            },
            slideActiveClass: '-active',
            slideClass: 'js-slider_slide',
            wrapperClass: 'js-slider_wrapper',
        };

        // 各スライダー毎のパラメータ
        const addParams = {
            subKv: {
                allowTouchMove: false,
                autoplay: false,
                on: {
                    slideChangeTransitionStart(swiper) {
                        const $prev = swiper.slides.find((slide) => slide.dataset.swiperSlideIndex == prevIndex);
                        const animate = AnimeUtils.getFadeOut($prev, 300, 0);
                    },
                    slideChangeTransitionEnd(swiper) {
                        const $active = swiper.slides[swiper.activeIndex];
                        const animate = AnimeUtils.getOutBack($active, 30, 600, 150);
                        prevIndex = $active.dataset.swiperSlideIndex;
                    },
                },
                speed: 0,
            },
            mainKv: {},
            bnr: {
                navigation: false,
                slidesPerView: MAIN_WIDTH / (BNR_WIDTH + ConvertUtils.remToPx(1)),
                spaceBetween: ConvertUtils.remToPx(2),
            },
        };

        for (const $slider of $sliders) {
            const $wrapper = $slider.querySelector('.js-slider_wrapper');
            const $slides = [...$wrapper.querySelectorAll('.js-slider_slide')];
            const { key } = $slider.dataset;

            // バナーのスライド数が定数以上のとき、ループ用に複製
            if (key === 'bnr' && $slides.length >= NUM_ALLOWED_LOOP) {
                for (let i = 0; i < 2; i++) {
                    $slides.forEach(($slide) => $wrapper.append($slide.cloneNode(true)));
                }
            }

            // スライド数が定数以上のとき、ループさせる
            addParams[key].loop = $slides.length >= NUM_ALLOWED_LOOP;

            // 共通のパラメータと各スライダー毎のパラメータをマージ
            const params = ObjUtils.deepMerge(commonParams, addParams[key]);

            this.swipers[key] = new Swiper($slider, params);
            this.swipers[key].count = $slides.length;
        }
    }

    _setBnrBullets() {
        const { bnr } = this.swipers;
        const { count } = bnr;
        const { bullets } = bnr.pagination;

        if (NUM_ALLOWED_LOOP > count) return;

        // 複製したスライド分の bullet を削除
        bullets.slice(count).forEach(($bullet) => $bullet.remove());

        // スライド切替で bullet を制御
        bnr.on('slideChange', () => {
            const realIndex = bnr.realIndex % count;
            bullets.forEach(($bullet, i) => $bullet.classList.toggle('-active', realIndex === i));
        });
    }
}
